import { BrowserRouter, Switch, Route } from "react-router-dom";

import DefRoutes from "./routes.json";

import SignIn from "../pages/auth/signin/signin";
import SignUp from "../pages/auth/signup/signup";
import Logout from "../pages/auth/logout/logout";
import Recovery from "../pages/auth/recovery/recovery";
import NewPassword from "../pages/auth/recovery/newPassword";
import TFA from "../pages/auth/tfa/tfa";

import Profile from "../pages/profile/profile";
import ChangePassword from "../pages/profile/changePassword";
import LoginSocial from "../pages/profile/loginSocial";

import Support from "../pages/support/support";
import Request from "../pages/support/request";
import Frequent from "../pages/support/frequent";
import Themes from "../pages/support/themes";
import Success from "../pages/support/success";
import View from "../pages/support/view";
import Response from "../pages/support/response";

import RechargeCenter from "../pages/recharge/center";
import RechargeLoyalMember from "../pages/recharge/loyalMember";
import RechargeCredit from "../pages/recharge/credit";
import RechargeCupons from "../pages/recharge/cupons";

import LoyalMember from "../pages/loyalMember/loyalMember";
import Rewards from "../pages/loyalMember/rewards";
import DailyDraw from "../pages/loyalMember/dailyDraw";

import WhatsIsIt from "../pages/loyalMember/static/whatIsIt";
import Benefits from "../pages/loyalMember/static/benefits";

import { ProfileIFrame, SignInIFrame, SignUpIFrame } from "../pages/iframes";

import MainLogin from "../pages/build/main";
import PageProfile from "../pages/build/Profile";
import { AppProfile, AppSignIn, Play } from "../pages/app";
import HeaderProfile from "../pages/iframes/header-profile";
import TFAIFrame from "../pages/iframes/tfa/tfa";
import asyncComponent from "../components/asyncComponent";
import EditUserProfile from "../pages/admin/editUser/editUserProfile";
import EditUserPassword from "../pages/admin/editUser/editUserPassword";
import EditUserLoginSocial from "../pages/admin/editUser/editUserLoginSocial";
import { SearchResult } from "../pages/support/searchResult";
import ChangeEmail from "../pages/profile/changeEmail";
const Admin = asyncComponent(() => import("../pages/support/admin"));

function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={DefRoutes.Home} component={Profile} />

        <Route exact path={DefRoutes.SignIn} component={SignIn} />
        <Route exact path={DefRoutes.SignUp} component={SignUp} />
        <Route exact path={DefRoutes.Logout} component={Logout} />
        <Route exact path={DefRoutes.RecoveryPassword} component={Recovery} />
        <Route exact path={DefRoutes.CreateNewPassword} component={NewPassword} />
        <Route exact path={DefRoutes.TFA} component={TFA} />

        <Route exact path={DefRoutes.Profile} component={Profile} />
        <Route exact path={DefRoutes.ChangePassword} component={ChangePassword} />
        <Route exact path={DefRoutes.LoginSocial} component={LoginSocial} />

        <Route exact path={DefRoutes.Support} component={Support} />
        <Route exact path={DefRoutes.ResponseFaq} component={Response} />
        <Route exact path={DefRoutes.SupportSuccess} component={Success} />
        <Route exact path={DefRoutes.ViewTicket} component={View} />
        <Route exact path={DefRoutes.Request} component={Request} />
        <Route exact path={DefRoutes.Frequent} component={Frequent} />
        <Route exact path={DefRoutes.Admin} component={Admin} />
        <Route exact path={DefRoutes.Themes} component={Themes} />
        <Route exact path={DefRoutes.ThemesWithId} component={Themes} />
        <Route exact path={DefRoutes.Search} component={SearchResult} />

        <Route exact path={DefRoutes.RechargeCenter} component={RechargeCenter} />
        <Route exact path={DefRoutes.RechargeLoyalMember} component={RechargeLoyalMember} />
        {/* <Route exact path={DefRoutes.RechargeCredit} component={RechargeCredit} /> */}
        <Route exact path={DefRoutes.RechargeCupons} component={RechargeCupons} />

        <Route exact path={DefRoutes.LoyalMember} component={LoyalMember} />
        <Route exact path={DefRoutes.WhatsIsIt} component={WhatsIsIt} />
        <Route exact path={DefRoutes.Benefits} component={Benefits} />

        <Route exact path={DefRoutes.Rewards} component={Rewards} />
        <Route exact path={DefRoutes.RewardsType} component={Rewards} />
        <Route exact path={DefRoutes.DailyDraw} component={DailyDraw} />

        <Route exact path={DefRoutes.MainLogin} component={MainLogin} />
        {/*<Route exact path={DefRoutes.AdminContent} component={AdminContent} />*/}

        <Route exact path={DefRoutes.MainProfile} component={PageProfile} />

        <Route exact path={DefRoutes.ChangeEmail} component={ChangeEmail} />

        <Route exact path={DefRoutes.Embed.Profile} component={ProfileIFrame} />
        <Route exact path={DefRoutes.Embed.SignIn} component={SignInIFrame} />
        <Route exact path={DefRoutes.Embed.SignUp} component={SignUpIFrame} />
        <Route exact path={DefRoutes.Embed.HeaderProfile} component={HeaderProfile} />
        <Route exact path={DefRoutes.Embed.TFA} component={TFAIFrame} />

        <Route exact path={DefRoutes.App.Profile} component={AppProfile} />
        <Route exact path={DefRoutes.App.SignIn} component={AppSignIn} />
        <Route exact path={DefRoutes.App.Play} component={Play} />

        <Route exact path={DefRoutes.EditUserProfile} component={EditUserProfile} />
        <Route exact path={DefRoutes.EditUserPassword} component={EditUserPassword} />
        <Route exact path={DefRoutes.EditUserLoginSocial} component={EditUserLoginSocial} />
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;
